import { render } from "./Marks.vue?vue&type=template&id=65a8809a"
import script from "./Marks.vue?vue&type=script&lang=js"
export * from "./Marks.vue?vue&type=script&lang=js"

import exportComponent from "/home/stagingfloretcollegein/staging.floretcollege.in/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__